<template>
    <div class="post-listing-wrapper">
        <infinite-scroller-vertical @scrolledTillBottom="onReachScrollBottom">
            <template v-for="(post, index) in posts">
                <card-list-item @likesClick="onLikesClick" :key="'c-'+index" :post="post" :class="{'mb-4': isDesktop}"></card-list-item>
                <div v-if="index === 2 && !isDesktop" :key="'suggestion-'+index">
                    <v-divider></v-divider>
                    <widget-suggestions-mobile class="py-4"></widget-suggestions-mobile>
                    <v-divider></v-divider>
                </div>
            </template>
            <div v-if="postListLoading">
                <v-skeleton-loader v-for="(n, i) in 3" :key="`post-loader-${i}`" type="list-item-avatar-two-line, image, article" class="mt-5"></v-skeleton-loader>
            </div>
        </infinite-scroller-vertical>
        <generic-dialog v-if="isDesktop" v-model="likesDialog" title="Liked by">
            <likes-list v-if="likesDialog" :postId="+activePostId" style="height: 100%"></likes-list>
        </generic-dialog>
    </div>
</template>
<script>
import {
    GET_POST_LIST
} from "@/store/actions.type"

import {
    CLEAR_POST_LIST
} from "@/store/mutations.type"

import genericDialog from "@/components/dialogs/generic-dialog.vue"
import likesList from "@/components/list/list-likes.vue"

export default {
    components: {
        likesList,
        genericDialog
    },
    created() {
        if (this.posts.length === 0) {
            this.$store.commit(CLEAR_POST_LIST) // resting all page variables and post
            this.$store.dispatch(GET_POST_LIST)
        }
    },
    data: () => ({
        likesDialog: false,
        activePostId: null
    }),

    methods: {

        onReachScrollBottom(val) {
            if (val) {
                if (!this.$store.state.post.postListFetchCompleted && !this.postListLoading) this.$store.dispatch(GET_POST_LIST)
            }
        },

        onLikesClick(postId) {
            this.activePostId = postId
            this.likesDialog = true
        }
    },

    destroyed() {
        //this.$store.commit(CLEAR_POST_LIST)
    },

    computed: {
        posts() {
            return this.$store.state.post.posts
        },

        postListLoading() {
            return this.$store.state.post.postListLoading
        }
    }


}
</script>